import React, { createContext, useContext, useState } from "react";

const ServerDownContext = createContext();

export const useServerDown = () => {
    const context = useContext(ServerDownContext);
    if (!context) {
        throw new Error("useServerDown must be used within a ServerDownProvider");
    }
    return context;
};

export const ServerDownProvider = ({ children }) => {
    const [isServerDown, setIsServerDown] = useState(false);

    const showServerDownDialog = () => {
        setIsServerDown(true);
    };

    const hideServerDownDialog = () => {
        setIsServerDown(false);
    };

    return (
        <ServerDownContext.Provider
            value={{
                isServerDown,
                showServerDownDialog,
                hideServerDownDialog,
            }}
        >
            {children}
        </ServerDownContext.Provider>
    );
};